/** The wordmark glyph from both mockups: a rounded square around a tape line. */
export function Mark({ size = 26 }: { size?: number }) {
  return (
    <svg
      className="mark"
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
      aria-hidden="true"
    >
      <rect x="1" y="1" width="28" height="28" rx="7" stroke="#B6FF3C" strokeWidth="1.7" />
      <polyline
        points="6,21 11,21 14,10 18,24 21,15 24,15"
        stroke="#B6FF3C"
        strokeWidth="1.9"
        strokeLinejoin="round"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
